import {
  LIST_USER,
  UPDATE_PASS_BULK,
  CREATE_USER,
  ACTIVATE_USER,
  UPDATE_USER,
  REFRESH_TOKEN,
  CREATE_PASSWORD,
  USER_RESEND_ACTIVATION,
  DELETE_USER,
  FORGOT_PASSWORD,
  LOGOUT,
} from '../constant'
import axios from 'axios'
import * as REPO from '../helper/main'

const localKey = 'token'

export const updatePassBulk = (data) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  //   let param = REPO.bikinParam(body)
  return axios.post(UPDATE_PASS_BULK, data, config_token)
}

export const getListUser = (body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(LIST_USER + param, config_token)
}

export const forgotPassword = (body) => {
  let param = REPO.bikinParam(body)
  return axios.get(FORGOT_PASSWORD + param)
}

export const refreshToken = () => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(REFRESH_TOKEN, config_token)
}

export const postUser = (data) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.post(CREATE_USER, data, config_token)
}

export const lgoutUser = (data) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.post(LOGOUT, data, config_token)
}

export const updateUser = (data, id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.put(UPDATE_USER + id, data, config_token)
}

export const activateUser = (data, id) => {
  return axios.put(CREATE_PASSWORD + id, data)
}

export const getActivateUser = (id) => {
  return axios.get(ACTIVATE_USER + id)
}

export const resendActivation = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(USER_RESEND_ACTIVATION + id, config_token)
}

export const deleteUser = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.delete(DELETE_USER + id, config_token)
}
